import { service } from '@ember/service'
import Route from '@ember/routing/route'
import RSVP from 'rsvp'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type SessionService from 'district-ui-client/services/session'
import type ReportingUiScopeRoute from 'district-ui-client/reporting/ui-scope/route'
import type { NormalizedInterval } from 'date-fns'
import type { DistrictScope } from 'district-ui-client/utils/student-events/stats-scope'

export default class RexDashboardTableRoute extends Route {
  @service studentEvents!: StudentEventsService

  @service session!: SessionService

  async model() {
    const { period, scopedData, uiScope } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    // The /summary endpoint is overused and returns different data for the school scope. We need to always call it
    // with district scope
    const statsScope: DistrictScope = { scope: 'district', ids: [this.session.currentDistrict.id] }

    const product = 'rex'
    const stats = await this.makeStatsRequest(product, statsScope, period)

    // if the scope was school, remove unrelated data from the stats.
    if (uiScope.scope === 'school' && stats.summary?.schools) {
      stats.summary.schools = stats.summary.schools.filter((schoolData) => String(schoolData.school_id) === uiScope.id)
    }

    return {
      product,
      period,
      scopedSchools: scopedData.schools,
      ...stats,
    }
  }

  makeStatsRequest = (product: LegacyProductRex, scope: DistrictScope, period: NormalizedInterval) => {
    return RSVP.hash({
      summary: this.studentEvents.summaryRex(product, scope, period),
    })
  }
}
